function formatClosingTime(date){
    const newDate = new Date(date);
     //return `${newDate.getUTCHours()}:${newDate.getUTCMinutes()}:${newDate.getUTCSeconds()}`;
     return newDate.toUTCString()
   }

   export {formatClosingTime}